import styled from 'styled-components';

export const SiteMachinesTableWidgetContainer = styled.div`
  display: flex;
  width: 100%;
`;
